import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class InternationalSearchProxy extends ProxyBase {
  getCompany(params) {
    return this.get('Company', params)
  }
}

export default new InternationalSearchProxy('InternationalSearch/')
